import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeaderTop from '../../../components/HeaderTop'
import Breadcumb from '../../../components/Breadcumb'
import NewsLetter from '../../../components/Newsletter'
import FooterArea from '../../../components/FooterArea'
import Portfolio from '../../../components/Portfolio'
import ContactArea from '../../../components/ContactArea'

// images
import breadcumb from '../../../images/breadcumb/1.jpg'
import team from '../../../images/Attorneys-single/2.jpg'
import portfolio1 from '../../../images/studies/1.jpg'
import portfolio2 from '../../../images/studies/2.jpg'
import portfolio3 from '../../../images/studies/3.jpg'

import './style.scss'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Team', route: '/team' },
    { name: 'Team Details' }
]
const teamMembarInfo = [
    { level: 'Phone: ', text: '415.297.1898' },
    { level: 'Email: ', text: 'jennifer@ziermanestradalaw.com' },
]
const teamContents = [

]

const portfolioItem = [
    { images: portfolio1, title: 'General Service', subtitle: 'Corporate' },
    { images: portfolio2, title: 'Personal Issue', subtitle: 'General' },
    { images: portfolio3, title: 'Business Accounting', subtitle: 'Business' },
]

const SingleTeamPageJennifer = () => {
    return (
        <Fragment>
             <header className="headerArea">
                <HeaderBotton className="headerBottomArea" />
            </header>
            <Breadcumb
                className="breadcumbArea"
                title="Our Team"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />
            <div className='singleTeamArea'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-12">
                            <div className="row">
                                <div className="col-md-4 col-12">
                                    <div className="singleTeamImgWrap">
                                        <h4>Jennifer Estrada</h4>
                                        <div className="singleTeamImg">
                                            <img src={team} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-12">
                                    <div className="singleTeamInfo">
                                        <h3>Personal Experience</h3>
                                        <p>Jennifer graduated with a Bachelor of Arts from Santa Clara University and earned her Juris Doctor from UC Law San Francisco (formerly UC Hastings). She started her career working in civil litigation and employment law. For the last several years she has focused on raising her three children and managing a family trust. Her passion for estate planning grew from her desire to make estate planning accessible and understandable for everyone. Her approach combines thorough legal knowledge with clear communication and an empathetic ear, counseling clients so they fully understand their options and feel confident in their decisions.</p>
                                        <ul>
                                            {teamContents.map(teamContent => (
                                                <li key={teamContent}>{teamContent}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                            <div className="col-12">
                                <div className="singleTeamContent">
                                    <h4>Contact Information</h4>
                                    <ul className="teamMembarInfo">
                                        {teamMembarInfo.map((teamInfo, i) => (
                                            <li key={i}>
                                                <span>{teamInfo.level} {teamInfo.text}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="socialShare">
                                        <li><a href="https://www.linkedin.com/in/jennifer-estrada-11915211/"><i className="fa fa-linkedin"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    <ContactArea
        className="contactArea"
    />

    <FooterArea/>
</Fragment>
)
}
export default SingleTeamPageJennifer